/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

export enum CMEQuestionEnum {
  IS_VALUE,
  SCIENTIFICALLY_SOUND,
  BIAS,
  IMPROVE,
  IMPACT,
}

export const CMEQuestionsMap = new Map<number, string>([
  [CMEQuestionEnum.IS_VALUE, 'Was the educational content of value to you?'],
  [CMEQuestionEnum.SCIENTIFICALLY_SOUND, 'Was the educational content scientifically sound?'],
  [CMEQuestionEnum.BIAS, 'Was this CME activity free of commercial bias?'],
  [
    CMEQuestionEnum.IMPROVE,
    'Did this program improve your skill or strategy in your role or contribution as a member of the healthcare team?',
  ],
  [
    CMEQuestionEnum.IMPACT,
    'Do you believe your participation in this activity will positively impact your healthcare team?',
  ],
]);

export type CMEQuestionnaireResponseTemplateType = {
  question: CMEQuestionEnum;
  answerYesOrNo?: boolean;
  answerFreeText?: string;
  hideTextArea?: boolean;
};
